<template lang="pug">
validation-observer(
  ref="observer",
  v-slot="{ invalid }",
  :persist="true",
  vid="acgForm"
)
  div
    DialogSave
  v-form
    v-tabs(v-model="tab", vertical, right)
      v-tab.hidden-sm-and-down.acgdig-left(
        v-for="item in acgTabs",
        :key="item.tab",
        @click="tabClick()"
      ) {{ item.tab }}
      v-tabs-items(v-model="tab")
        v-card-actions
          v-btn(@click="backTab()", :disabled="tab === 0") Back
          v-card-actions(v-if="tab < 15")
            v-btn(
              color="primary",
              @click="save(false, 'save')",
              skipSuccess,
              :disabled="data.disabled || data.SEA_SubmitterEmail === null"
            ) Save
          v-card-actions(v-if="tab < 15")
            v-btn.white--text(
              @click="progressTab()",
              skipSuccess,
              color="#e38410",
              :right="true",
              :absolute="true"
            ) Continue
        v-tab-item
          o0Intro
        v-tab-item
          o15Submitter
        v-tab-item
          o01GeneralEvent
        v-tab-item
          o02EventMgr
        v-tab-item
          o03SponsorInformation
        v-tab-item
          o04FinancialInformation
        v-tab-item
          o05PublicSafety
        v-tab-item
          o06EventPublicity
        v-tab-item
          o07SiteInfo
        v-tab-item
          o08Trash
        v-tab-item
          o09Parking
        v-tab-item
          o10Restrooms
        v-tab-item
          o11LocationImpact
        v-tab-item
          o12Signage
        v-tab-item
          o13Food
        v-tab-item
          v-card(flat, v-if="allTabsAlive")
            div(v-if="data.SEA_IsThisaSingle === 'Series' &&  data.events.length === 0")
              v-card-title Your form is not complete
              v-container
                v-row
                  v-col(:lg="12", :md="12", :sm="12", :cols="12")
                    p.pb-0 You have selected a series of events, but have added no dates.
                    p.pb-0 Please return to the General tab and add in dates.
            div(v-else)
              div(v-if="!invalid")
                v-card-title Arlington County Special Event Hold Harmless Agreement
                o14HoldHarmless
                div
                  v-container
                    v-row
                      v-col(:lg="12", :md="12", :sm="12", :cols="12")
                        p.pb-0.text--lighten-1.pl-4 Please sign your name below
                        VueSignaturePad#signature(
                          width="500px",
                          height="250px",
                          style="border: 1px solid black",
                          ref="signaturePad"
                        )

                        p.pb-0.text--lighten-1.pl-4(v-if="isSaving") Saving signature...
                        p.pb-0.text--lighten-1.pl-4(v-if="isSuccess") Signature saved.
                        p.pb-0.red--text.text--lighten-1.pl-4(v-if="isFailed") Signature failed, please save, refresh, and try again.
                        p.pb-0.red--text.text--lighten-1.pl-4(
                          v-if="emptySignature"
                        ) Required signature
                      v-col(:lg="12", :md="12", :sm="12", :cols="12")
                        v-btn.white--text(
                          :disabled="data.disabled || invalid",
                          skipSuccess,
                          @click="submit()",
                          color="#e38410"
                        )
                          v-icon mdi-signature
                          span Save &amp; Submit
              div(v-else)
                v-card-title Your form is not complete
                v-container
                  v-row
                    v-col(:lg="12", :md="12", :sm="12", :cols="12")
                      p.pb-0 Please review your form for missing required answers.
          v-card(flat, v-else)
            v-card-title Your form is not complete
            v-container
              v-row
                v-col(:lg="12", :md="12", :sm="12", :cols="12")
                  p.pb-0 You must complete the following sections:
                  ul(
                    v-for="tabb in tabToBeCompleted",
                    :key="tabb",
                    style="list-style-type: none"
                  )
                    li {{ acgTabs[tabb].tab }}
        v-tab-item
          o16PrintOther
        v-card-actions
          v-btn(@click="backTab()", :disabled="tab === 0") Back
          v-card-actions(v-if="tab < 15")
            v-btn(
              color="primary",
              @click="save(false, 'save')",
              skipSuccess,
              :disabled="data.disabled || data.SEA_SubmitterEmail === null"
            ) Save
            v-btn.white--text(
              @click="progressTab()",
              skipSuccess,
              color="#e38410",
              :right="true",
              :absolute="true"
            ) Continue
        v-overlay(:value="overlay")
          v-progress-circular(indeterminate, color="primary")
</template>

<script>
import o0Intro from "./o0Intro.vue";
import o01GeneralEvent from "./o01GeneralEvent.vue";
import o02EventMgr from "./o02EventMgr.vue";
import o03SponsorInformation from "./o03SponsorInformation.vue";
import o04FinancialInformation from "./o04FinancialInformation.vue";
import o05PublicSafety from "./o05PublicSafety.vue";
import o06EventPublicity from "./o06EventPublicity.vue";
import o07SiteInfo from "./o07SiteInfo.vue";
import o08Trash from "./o08Trash.vue";
import o09Parking from "./o09Parking.vue";
import o10Restrooms from "./o10Restrooms.vue";
import o11LocationImpact from "./o11LocationImpact.vue";
import o12Signage from "./o12Signage.vue";
import o13Food from "./o13Food.vue";
import o14HoldHarmless from "./o14HoldHarmless.vue";
import o15Submitter from "./o15Submitter.vue";
import o16PrintOther from "./o16PrintOther.vue";
import DialogSave from "./DialogSave.vue";
import store from "../store";
import service from "../data/service";
import { mapActions, mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapFields } from "vuex-map-fields";
import VueSignaturePad from "vue-signature-pad";

// change for pull request

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

const scrollTo = 0; // 232

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    o0Intro,
    o01GeneralEvent,
    o02EventMgr,
    o03SponsorInformation,
    o04FinancialInformation,
    o05PublicSafety,
    o06EventPublicity,
    o07SiteInfo,
    o08Trash,
    o09Parking,
    o10Restrooms,
    o11LocationImpact,
    o12Signage,
    o13Food,
    o14HoldHarmless,
    o15Submitter,
    o16PrintOther,
    DialogSave,
    VueSignaturePad,
  },
  store,
  methods: {
    ...mapActions([
      "setDraftFields",
      "setDocId",
      "setDialogSave",
      "setDialogTxt",
    ]),
    progressTab() {
      this.letsCheckTheTabs();
      this.tab = this.tab + 1;
      window.scrollTo(0, scrollTo);
    },
    backTab() {
      this.letsCheckTheTabs();
      this.tab = this.tab - 1;
      window.scrollTo(0, scrollTo);
    },
    tabClick() {
      this.letsCheckTheTabs();
      window.scrollTo(0, scrollTo);
    },
    letsCheckTheTabs() {
      this.tabToBeCompleted = this.tabToBeCompleted.filter(
        (element) => element !== this.tab
      );
      if (this.tabToBeCompleted.length === 0) {
        this.allTabsAlive = true;
      }
    },
    async save(submitApp, dialogTxt) {
      this.$refs.observer.validate();
      const saveRes = await service
        .save(this.data, this.data.id, submitApp)
        .then(async (response) => {
          let resposeData = await response.json();
          return resposeData;
        })
        .catch((err) => {
          console.log(err.response);
          alert("Wasn't able to save. Please try again or reach out to lpelze@arlingtonva.us")
        })
      this.$store.commit("setDocId", saveRes.docId);
      this.$store.commit("setDialogSave", true);
      this.$store.commit("setDialogTxt", dialogTxt);
      this.overlay = false;
    },
    async submit() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.emptySignature = true;
      } else {
        this.emptySignature = false;
        this.overlay = true;
        this.data.signature = data;
        this.data.disabled = true;
        await service
          .uploadSignature(data, "signature.png", this.data.id)
          .then(async (returnResponse) => {
            console.log({ returnResponse: returnResponse });
            this.currentStatus = STATUS_SUCCESS;
          })
          .catch((err) => {
            console.log(err);
            this.uploadError = err.response;
            console.log(this.uploadError);
            this.currentStatus = STATUS_FAILED;
          });
        if (this.data.specialEventId === null) {
          const newId = await service.getId(params)
          .then(async (response) => {
            let data = await response.json();
            return data.id;
          })
          .catch((err) => {
            console.log(err.response);
            alert("Didn't get an ID assigned.")
          })
          
          console.log({newId: newId})
          if (typeof newId != 'string') {
            alert('Something went wrong.');
          }
          this.data.specialEventId = newId;
        }
        this.save(true, "submit");
      }
    },
  },
  actions: {
    setDraftFields(state, value) {
      state.data = value;
    },
    setDocId(state, value) {
      state.data.id = value;
    },
    setDialogSave(state, value) {
      state.dialogSave = value;
    },
    setDialogTxt(state, value) {
      state.dialogTxt = value;
    },
  },
  computed: {
    ...mapState({
      data: (state) => state.data,
      acgTabs: (state) => state.acgTabs,
    }),
    ...mapFields(["dialogSave"]),
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  mutations: {},
  async created() {
    if (urlSearchParams.has("docId")) {
      const draft = await service.get(params).then(async (response) => {
        let resposeData = await response.json();
        let data = service.breakupPackage(resposeData);
        return data;
      });
      this.$store.commit("setDraftFields", draft);
    }
  },

  data() {
    return {
      tab: 0,
      tabToBeCompleted: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
      allTabsAlive: false,
      emptySignature: false,
      uploadError: null,
      currentStatus: null,
      overlay: false,
    };
  },
};
</script>
